<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Үндэсний эрүүл мэндийн даатгалын үйлчилгээний талаарх мэдээлэл</h3>
            <h4 class="bullet02">Эрүүл мэндийн даатгал</h4>
            <p class="depth">
                И-хуа Эмэгтэйчүүдийн их сургуулийн Анагаах ухааны төв нь ерөнхий нарийн мэргэжлийн тусламж үйлчилгээ үзүүлдэг байгууллага юм.(3-р шатлал) <br>
                Манай төвд анх удаа үзүүлж байгаа өвчтөн эрүүл мэндийн даатгалын дэвтэрээ 1 юм уу 2-р шатлалын эмнэлгээс олгосон үзлэгийн хүсэлт, эмчилгээний лавлагааны хамт бүртгэлийн ажилтанд өгч эрүүл мэндийн даатгалын хөнгөлөлт авах боломжтой. (Шүдний эмнэлэгт үзүүлж буй өвчтөн, яаралтай тусламж болон төрөхөөр ирсэн үйлчлүүлэгч үзлэгийн хүсэлтгүйгээр эрүүл мэндийн даатгалын хөнгөлөлт авч болно.)
            </p>
            <h4 class="bullet02">Нарийн мэргэжлийн эрүүл мэндийн тусламж үйлчилгээ (үзлэг эмчилгээ)</h4>
            <p class="depth">Төвийн бүх тасагт эмчлүүлэгч өвчтөнүүд нарийн мэргэжлийн эрүүл мэндийн байгууллагаас (эмнэлэг) гаргасан үзлэгийн хүсэлтээ өгсний үндсэн дээр даатгалын (үзлэг эмчилгээний) хөнгөлөлт эдэлнэ.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>